import { cn } from "@/cn";
import { PERSON_TABS, type PersonTabId } from "./person-hero";

export function PersonTabs({
  active,
  onChange,
}: {
  active: PersonTabId;
  onChange: (tab: PersonTabId) => void;
}) {
  return (
    <div
      role="tablist"
      className="flex max-w-full flex-wrap gap-1 border-b border-border"
    >
      {PERSON_TABS.map((tab) => {
        const selected = tab.id === active;
        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={selected}
            onClick={() => onChange(tab.id)}
            className={cn(
              "-mb-px border-b-2 px-3 py-2.5 text-sm font-medium transition-colors",
              selected
                ? "border-brand text-foreground"
                : "border-transparent text-muted-foreground hover:text-foreground",
            )}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
